<template>
  <div>
    <a-row class="row">
      <a-col :span="2" class="title" style="margin-left:165px;margin-right:15px;">收件人类型：</a-col>
      <a-col :span="8">
        <a-row>
          <a-checkbox
            @change="onChange"
            :defaultChecked="true"
            :value="author.authorCode"
            style="margin-bottom:10px;"
          >投稿作者&#12288;{{author.authorName}}&#12288;{{author.email}}</a-checkbox>
        </a-row>
        <a-row>
          <a-checkbox
            @change="onChange"
            :defaultChecked="true"
            :value="firstAuthor.authorCode"
            style="margin-bottom:10px;"
          >第一作者&#12288;{{firstAuthor.authorName}}&#12288;{{firstAuthor.email}}</a-checkbox>
        </a-row>
        <a-row v-for="item in corAuthor" :key="item.authorCode">
          <a-checkbox
            @change="onChange"
            :defaultChecked="true"
            :value="item.authorCode"
          >通讯作者&#12288;{{item.authorName}}&#12288;{{item.email}}</a-checkbox>
        </a-row>
      </a-col>
    </a-row>

    <a-row class="row">
      <a-col :span="2" class="title" style="margin-right:0;margin-left:180px;margin-top:4px;">邮件模板：</a-col>
      <a-col :span="3">
        <a-select
          style="width: 250px;"
          placeholder="请选择"
          @change="selectChange"
          v-model="templateCode"
        >
          <a-select-option
            v-for="(item,index) in emailTemplates"
            :value="item.templateCode"
            :key="index"
          >{{item.name}}（{{item.lang}}）</a-select-option>
        </a-select>
      </a-col>
    </a-row>

    <a-row class="row">
      <a-col :span="2" class="title" style="margin-left:180px;margin-top:4px;">邮件标题：</a-col>
      <a-col :span="2">
        <a-input v-model="emailTemplate.title" :readOnly="true" style="width:250px;"/>
      </a-col>
    </a-row>
    <a-row class="row">
      <a-col :span="2" class="title" style="margin-left:180px;margin-top:4px;">邮件内容：</a-col>
      <a-col :span="16">
        <a-textarea
          style="height:350px;width:700px"
          v-model="firstContent"
          id="textarea"
          :readOnly="true"
        ></a-textarea>
      </a-col>
    </a-row>
    <a-row class="row">
      <a-col :span="2" class="title" style="margin-left:180px;margin-top:4px;">短信内容：</a-col>
      <a-col :span="8">
        <a-textarea id="message_content" value="发短信..." :readOnly="true" style="height:100px;"></a-textarea>
      </a-col>
      <br>
      <a-col :span="4">
        <a-checkbox id="send_message" style="margin-left:20px;margin-top:14px;">发送短信</a-checkbox>
      </a-col>
    </a-row>
    <a-row class="row" style="margin-left:550px;margin-top:50px;">
      <a-button id="noSend" name="btn" class="btn" @click="noSend">取消</a-button>
      <a-button id="preview" name="btn" class="btn" @click="preview">预览</a-button>
      <a-button id="send" name="btn" class="btn" @click="send">发送</a-button>
    </a-row>
    <a-modal
      title="预览"
      v-model="visible"
      cancelText="关闭"
      okText="发送"
      @ok="send"
      @cancel="cancelPreview"
      centered
      width="800px"
    >
      <div>
        <a-row class="row">
          <a-col :span="4" class="title">邮件标题：</a-col>
          <a-col :span="12">
            <a-input v-model="emailTemplate.title" :readOnly="true"/>
          </a-col>
        </a-row>
        <a-row class="row">
          <a-col :span="4" class="title">邮件内容：</a-col>
          <a-col :span="18">
            <a-textarea style="height:350px;width:700px;" v-model="firstContent" id="textarea" :readOnly="true"></a-textarea>
          </a-col>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "returnReceipt",
  data() {
    return {
      visible: false,
      code: "",
      author: {},
      firstAuthor: {},
      corAuthor: [],
      sendList: [],
      emailTemplates: [],
      emailTemplate: { content: "", title: "" },
      templateCode: "",
      templateType: "",
      status: 1,
      routerPath: "",
      isSend: true,
      firstContent: ""
    };
  },
  created() {
    this.code = this.$route.query.code;
    this.templateType = this.$route.query.templateType;
    this.routerPath = this.$route.query.routerPath;

    this.axios
      .get("/emailTemplate/queryEmailTemplate", {
        params: {
          templateType: this.templateType,
          sortField: "template_code",
          page: 1,
          limit: 10,
          time: new Date().getTime()
        },
        paramsSerializer: function(p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        }
      })
      .then(res => {
        if (res.data.code == "0") {
          if (res.data.data.length == 0) {
            this.utils.messageInfo(this,"error","查询邮件模版失败！");
            this.isSend = false;
            return;
          }
          this.emailTemplates = res.data.data;
          this.emailTemplates.forEach(function(value) {
            if (value.lang == "CN") {
              value.lang = "中文";
            } else if (value.lang == "EN") {
              value.lang = "英文";
            }
          });
          this.emailTemplate = this.emailTemplates[0];
          this.templateCode = this.emailTemplate.templateCode;

          //查询邮件内容
          this.getContent();
        } else {
          this.utils.messageInfo(this,"error","查询邮件模版失败！");
        }
      });

    this.axios
      .get("/manuscripts/queryAuthorByCode", {
        params: {
          code: this.code,
          time: new Date().getTime()
        },
        paramsSerializer: function(p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        }
      })
      .then(res => {
        if (res.data.code == "OK") {
          this.author = res.data.data.author;
          this.firstAuthor = res.data.data.firstAuthor;
          this.corAuthor = res.data.data.corAuthor;
          this.sendList.push(this.author);
          this.sendList.push(this.firstAuthor);
          this.sendList = this.sendList.concat(this.corAuthor);
          this.sendList.forEach(function(value) {
            value.send = "1";
          });
        }
      });
  },
  methods: {
    cancelPreview() {
      this.visible = false;
    },
    getContent() {
      this.axios
        .get("/email/queryContent", {
          params: {
            code: this.code,
            emailContent: this.emailTemplate.content,
            time: new Date().getTime()
          },
          paramsSerializer: function(p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          }
        })
        .then(res => {
          this.firstContent = res.data;
        });
    },
    onChange(e) {
      var authorCode = e.target.value;
      var checked = e.target.checked;
      this.sendList.forEach(function(value) {
        if (checked) {
          if (value.authorCode == authorCode) {
            value.send = "1";
          }
        } else {
          if (value.authorCode == authorCode) {
            value.send = "0";
            e.target.checked = false;
          }
        }
      });
    },
    selectChange(value) {
      var tmp = {};
      this.emailTemplates.forEach(function(v) {
        if (v.templateCode == value) {
          tmp = v;
        }
      });
      this.emailTemplate = tmp;
      this.templateCode = this.emailTemplate.templateCode;

      //查询邮件内容
      this.getContent();
    },
    noSend() {
      this.$router.go(-1);
      // this.$router.push(this.routerPath);
    },
    preview() {
      this.visible = true;
    },
    send() {
      if (!this.isSend) {
        this.utils.messageInfo(this,"error","无法发送邮件！");
        return;
      }
      var list = [];
      for (var i = 0; i < this.sendList.length; i++) {
        if (this.sendList[i].send == 1) {
          list.push(this.sendList[i]);
        }
      }
      //发送邮件
      this.axios
        .post("/email/send", {
          code: this.code,
          sendList: list,
          subject: this.emailTemplate.title,
          text: this.emailTemplate.content
        })
        .then(res => {
          if (res.data.code == "OK") {
            this.$router.push(this.routerPath);
          } else {
            this.utils.messageInfo(this,"error","发送失败！");
          }
        });
    }
  }
};
</script>

<style scoped>
.row {
  margin-top: 20px;
  margin-bottom: 20px;
}
.btn {
  color: #1890ff;
  border-color: #1890ff;
  margin: 0 10px;
}
#send {
  color: #fff;
  background-color: #1890ff;
  border-color: #1890ff;
}
#send_message {
  margin-left: 20px;
}
</style>
